import React from "react";
import "./Infor.css";

const Informations = () => {
  return (
    <div className="info-container">
      <h2 className="info-title">MAELEKEZO</h2>

      <div className="info-grid">
        {/* ================= LEFT – WITHDRAW ================= */}
        <div className="info-card left">
          <h3 className="info-subtitle">Jinsi ya Kutoa Pesa</h3>

          <ul className="info-list">
            <li>✔ Lazima uwe umejisajili kikamilifu kwenye mfumo</li>
            <li>✔ Nenda <strong>Settings</strong> kisha chagua <strong>Secure My Account</strong></li>
            <li>✔ Jaza taarifa zako zote kwa usahihi</li>
            <li>✔ Taarifa lazima zifanane na ulizotumia wakati wa kujisajili</li>
            <li>✔ Weka PIN ya kutoa pesa (Withdrawal PIN)</li>
            <li>✔ Hakikisha umechagua mtandao sahihi wa malipo</li>
          </ul>

          <p className="info-note">
            ⚠ Bila kukamilisha sehemu ya <strong>Settings</strong>, 
            hutaweza kutoa pesa hata kama una balance.
          </p>

          <p className="info-note success">
            🔐 Ukifanikiwa kujaza taarifa zote kwa usahihi,
            akaunti yako inalindwa kwa kiwango cha juu
            na usalama wake hudumu kwa zaidi ya <strong>miaka 20</strong>.
          </p>
        </div>

        {/* ================= RIGHT – HOW TO PLAY ================= */}
        <div className="info-card right">
          <h3 className="info-subtitle">Jinsi ya Kucheza</h3>

          <ul className="info-list">
            <li>✔ Chagua mchezo uliopo kwenye mfumo</li>
            <li>✔ Akikisha kwenye dashboard yako kuna kiasi cha kutosha TZS AU USDT</li>
            <li>✔ Mfumo huu ni <strong>Reverse Betting</strong></li>
            <li>✔ Angalia Navbar  Chagua Page ya Markets Utukaribishwa utaingia ukurasa wa matches</li>
            <li>✔ Kisha Juu kwenye TopBar utaona Matches yenye No Risk chagua hiyo pamoja na score iliyeko mbele baada ya kubofya akikisha umeweka score na odds sahii  </li>
            <li>✔ Iwapo ukichagua No Risk na score au wezi kupoteza (No risk ni bet yenye ulinzi)</li>
            <li>✔ Unacheza kwa kuchagua kile ambacho <strong>HAKITATOKEA</strong></li>
            <li>✔ Chagua matokeo machache (si zaidi ya yaliyoruhusiwa)</li>
           
            <li>✔ Weka kiasi cha kucheza kulingana na balance yako</li>
            <li>✔ Thibitisha mchezo wako kabla ya muda kuisha</li>
          </ul>

          <p className="info-note">
            ℹ Reverse betting inakupa nafasi ya kufikiria kwa umakini
            zaidi kuliko kubahatisha.
          </p>

          <p className="info-note success">
            🧠 Cheza kwa akili. Betting ni burudani,
            si chanzo cha kipato cha uhakika.
          </p>
        </div>
      </div>

      <div className="info-footer">
        <p>© {new Date().getFullYear()} AntBet FOOTBALL</p>
        <p>Play Responsibly • Secure Your Account</p>
      </div>
    </div>
  );
};

export default Informations;